module.exports = __webpack_public_path__ + "static/img/563.e19bf07.png";